// src/lib/api.js
import { ensureToken } from './token';

const API_BASE = process.env.REACT_APP_API_URL || '';

export async function api(path, opts = {}) {
  const headers = { ...(opts.headers || {}) };

  // Public requests skip auth
  if (!opts.public) {
    const token = localStorage.getItem('fq_token') || await ensureToken();
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (opts.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE}/api${path}`, {
    ...opts,
    headers,
    credentials: 'include',
  });

  // accept 200 OK and 201 Created
  if (res.status !== 200 && res.status !== 201) {
    const text = await res.text();
    throw new Error(`API ${path} ${res.status}: ${text}`);
  }

  return res.json();
}